import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from 'app/features/auth/data-access/auth.service';
import { catchError, map, of } from 'rxjs';

// Blocks access to login route when already authenticated.
export const guestGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // If already authenticated, redirect to home
  if (auth.isAuthenticated) {
    return router.createUrlTree(['/inicio']);
  }

  // If there is a refresh token, try to refresh and redirect to home on success
  if (auth.refresh) {
    return auth.refreshToken().pipe(
      map((): boolean | UrlTree => router.createUrlTree(['/inicio'])),
      catchError(() => of(true))
    );
  }

  // Allow access to login
  return true;
};

